(function () {
  document.addEventListener('DOMContentLoaded', function () {
    var root = document.querySelector('[data-stilloak-collection]');
    var filterTabs;
    var resultsCount;
    var cards;
    var emptyState;

    if (!root) {
      return;
    }

    filterTabs = root.querySelector('[data-filter-tabs]');
    resultsCount = root.querySelector('[data-results-count]');
    cards = Array.prototype.slice.call(root.querySelectorAll('[data-product-card]'));
    emptyState = root.querySelector('[data-no-results]');

    function updateCount(visibleCards) {
      var count = visibleCards.length;

      if (!resultsCount) {
        return;
      }

      resultsCount.textContent = count + (count === 1 ? ' product' : ' products');
    }

    function applyFilter(filterValue) {
      var visibleCards = [];

      cards.forEach(function (card) {
        var matches = filterValue === 'all' || card.getAttribute('data-product-type') === filterValue;

        card.classList.toggle('collection-card-hidden', !matches);

        if (matches) {
          visibleCards.push(card);
        }
      });

      if (emptyState) {
        emptyState.classList.toggle('collection-card-hidden', visibleCards.length !== 0);
      }

      updateCount(visibleCards);
    }

    if (filterTabs) {
      filterTabs.addEventListener('click', function (event) {
        var tab = event.target.closest('[data-filter]');

        if (!tab) {
          return;
        }

        filterTabs.querySelectorAll('[data-filter]').forEach(function (item) {
          item.classList.remove('active');
        });

        tab.classList.add('active');
        applyFilter(tab.getAttribute('data-filter'));
      });
    }

    applyFilter('all');
  });
})();
